import useStoreType from "../../../utils/hooks/useStoreType";
import { StoreBrandingType } from "../../../types/misc";
import SinglePageSkeletonFullLoading from "./SinglePageSkeletonFullLoading";
import StoreLoadingSkeletonFullSite from "./StoreLoadingSkeletonFullSite";

const StoreFullScreenLoading = ({
  storeHeader = false,
}: {
  storeHeader?: boolean;
}) => {
  const storeType = useStoreType();
  if (!storeType) {
    return null;
  }
  if (storeType === StoreBrandingType.CustomDTCStore) {
    return <SinglePageSkeletonFullLoading includeHeader={storeHeader} />;
  }
  return <StoreLoadingSkeletonFullSite header={storeHeader} />;
};

export default StoreFullScreenLoading;
